import { setAnalyticsCard, skeletonInit } from '../modules/setAnalyticsCard';

const api = '/ajax/itemsAnaliticalMarkets.php';

function getAnalyticalMarkets(date) {
    const url = `${api}?date=${date}`;

    fetch(url)
        .then((response) => response.json())
        .then((cards) => {
            setAnalyticsCard(cards);
            skeletonInit(false);
        })
        .catch((error) => console.log(error));
}

export default getAnalyticalMarkets;
